import React from 'react'

function FooterComp() {
    return (
        <div className="dash_footer">
            @2023 Hive. All rights reserved.
        </div>
    )
}

export default FooterComp
